import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Table } from 'react-bootstrap';
import LessonsButton from './LessonsButton';
import { getChild } from '../reducer';
import { loadChildLessons } from './actions';
import { fetchWeeklyInfo, WEEKLY_INFO_REQUEST, WEEKLY_INFO_SUCCESS, WEEKLY_INFO_FAILURE } from '../common/actions';
import { setPaymentSubGrade, SET_SUBGRADE_REQUEST, SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE } from '../payments/actions';
import { withNamespaces } from 'react-i18next';
import utils from '../../common/services/utils';
import moment from 'moment';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import GradeDetailsLink from '../../common/components/GradeDetailsLink';

class History extends Component {
    constructor(props) {
        super(props);
        this.handleLessonsButtonClick = this.handleLessonsButtonClick.bind(this);
        this.handleLoadWeeklyInfo = this.handleLoadWeeklyInfo.bind(this);
        this.handleSubGradeSelect = this.handleSubGradeSelect.bind(this);
    }

    handleSubGradeSelect(lesson, grade, onSuccess) {
        this.props.setPaymentSubGrade(lesson.paymentId, grade.id, () => {
            if (onSuccess) {
                onSuccess();
            }

            // update sub-grades for all lessons
            this.props.loadChildLessons({
                childId: this.props.child.id,
                programId: lesson.programId,
                forceReload: true
            });
        });
    }

    handleLoadWeeklyInfo(lesson, subGrade) {
        if (lesson) {
            const gradeId = lesson.grade.mixed ? lesson.subGradeId || subGrade.id : lesson.gradeId;
            this.props.fetchWeeklyInfo(gradeId, lesson.weekNumber, lesson.programId, lesson.start);
        }
    }

    handleLessonsButtonClick(programId) {
        this.props.loadChildLessons({
            childId: this.props.child.id,
            programId
        });
    }

    renderAttendedClass(programItem) {
        const { term, grade, center } = programItem;

        const { child, childLessons, childLessonsByChildAndProgram, grades, enableUserTimeZone, t } = this.props;

        const lessonsFilter = childLessonsByChildAndProgram[`${child.id}-${programItem.id}`] || { ids: [], loading: false };
        const lessons = lessonsFilter.ids.map(id => childLessons[id]);
        lessons.forEach(lesson => {
            lesson.grade = grades[lesson.gradeId] || { name: '', subGrades: [] };
            lesson.subGrade = lesson.subGradeId && grades[lesson.subGradeId];
        });

        return (<tr key={programItem.id}>
            <td className='purple'>
                <div><label>{t('FO_Dashboard_LabelTerm')}</label> {term.name}</div>
                <div><label>{t('FO_Dashboard_LabelGrade')}</label> <GradeDetailsLink grade={grade} /></div>
            </td >
            <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                <LessonsButton programItem={programItem} lessons={lessons} blocking={lessonsFilter.loading} onClick={() => this.handleLessonsButtonClick(programItem.id)}
                    weeklyInfos={this.props.weeklyInfos}
                    onLoadWeeklyInfo={this.handleLoadWeeklyInfo}
                    grades={grades}
                    center={center}
                    enableUserTimeZone={enableUserTimeZone}
                    onSubGradeSelect={this.handleSubGradeSelect}
                    subGradeBlock={SET_SUBGRADE_REQUEST}
                    subGradeUnblock={[SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE]}
                    weeklyInfoBlock={WEEKLY_INFO_REQUEST}
                    weeklyInfoUnblock={[WEEKLY_INFO_SUCCESS, WEEKLY_INFO_FAILURE]}
                />
            </td>
        </tr >);
    }

    render() {
        const { child, t } = this.props;

        if (!child) {
            return null;
        }

        const classes = child.attendedClasses;

        let classesByCenter = <p style={{ padding: '10px' }}>{t('FO_Common_NoResults')}</p>;

        if (classes.length > 0) {
            const centerGroups = utils.groupBy(classes, 'centerId');

            classesByCenter = Object.keys(centerGroups).map(key => {
                const groupedClasses = centerGroups[key].sort((a, b) => moment(b.term.startDate) - moment(a.term.startDate));
                const center = groupedClasses[0].center;

                return <div key={key}>
                    <h5><CenterDetailsLink center={center} /></h5>
                    <Table className='table-expanded'>
                        <tbody>
                            {groupedClasses.map(programItem => this.renderAttendedClass(programItem))}
                        </tbody>
                    </Table>
                </div>;
            });
        }

        return (
            <div>
                <h3>{t('FO_Child_History')}</h3>
                {classesByCenter}
                <Row>
                    <Col sm={12}>
                        <Link to='/children' className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('Common_BackToList')}</Link>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const childId = Number(ownProps.match.params.id);

    const { entities: { centers, terms, grades, weeklyInfos }, parent, configuration: { franchisor } } = state;

    const child = getChild(parent, childId);
    if (child && child.attendedClasses) {
        child.attendedClasses.forEach(programItem => {
            programItem.center = centers[programItem.centerId] || { name: '' };
            programItem.term = terms[programItem.termId] || { name: '' };
            programItem.grade = grades[programItem.gradeId] || { name: '' };
        });
    }

    return {
        child,
        childLessons: state.entities.childLessons,
        childLessonsByChildAndProgram: state.filters.childLessonsByChildAndProgram,
        grades,
        weeklyInfos,
        enableUserTimeZone: franchisor.enableUserTimeZone
    };
};

export default connect(mapStateToProps, {
    loadChildLessons,
    fetchWeeklyInfo,
    setPaymentSubGrade
})(withNamespaces()(History));